<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>H5 快速开始页配置</span>
                </div>
                <div class="title_desc">新用户扫码进入的快速开始页。按产品+语言独立配置，从列表进入详情页编辑内容并发布。</div>
            </div>

            <div class="search_box">
                <el-form :inline="true" class="search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-select v-model="searchProduct" placeholder="全部产品" clearable @change="filterTable">
                            <el-option :label="item" :value="item" v-for="item in productOptions" :key="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="filterTable">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <div class="btn_box">
                <div class="btn_right_box">
                    <div class="button button2 add" @click="openCreate" v-if="roleCheck('103-104-101-102')">
                        <i class="el-icon-plus"></i>
                        <span>新建配置</span>
                    </div>
                </div>
            </div>

            <el-table :data="tableData" v-loading="loading">
                <el-table-column label="产品" min-width="140">
                    <template slot-scope="scope">
                        <span>{{ productName(scope.row.product) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="语言" width="110">
                    <template slot-scope="scope">
                        <span>{{ appData.lang[scope.row.language] || scope.row.language }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="兜底语言" width="110">
                    <template slot-scope="scope">
                        <span>{{ scope.row.fallback ? (appData.lang[scope.row.fallback] || scope.row.fallback) : '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="170">
                    <template slot-scope="scope">
                        <div class="status_tags">
                            <span class="tag status_tag" :class="scope.row.published ? 'published' : 'none'">
                                {{ scope.row.published ? '已发布' : '未发布' }}
                            </span>
                            <span v-if="scope.row.hasDraftChange" class="tag status_tag draft">有草稿修改</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="最近更新" width="170">
                    <template slot-scope="scope">
                        <span>{{ formDate(scope.row.updatedAt) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <div class="button text" @click="goEdit(scope.row)" v-if="roleCheck('103-104-101-102')">配置</div>
                        <div class="button text" @click="publishRow(scope.row)" v-if="roleCheck('103-104-101-102') && scope.row.hasDraft">发布</div>
                        <div class="button text del_btn" @click="delRow(scope.row)" v-if="roleCheck('103-104-101-102')">删除</div>
                    </template>
                </el-table-column>
            </el-table>

            <Tip ref="tip" :msg="delMsg" @tipBack="delConfirm"></Tip>

            <!-- 新建配置弹窗 -->
            <Gh-Dialog size="true" ref="createDialog" title="新建配置" @dialogBack="confirmCreate">
                <template v-slot:cancel_btn>
                    <span></span>
                </template>
                <template v-slot:content>
                    <el-form label-width="100px" :model="createForm">
                        <el-form-item label="产品型号" required>
                            <el-select v-model="createForm.product" placeholder="请选择产品" style="width: 260px;">
                                <el-option :label="productName(item)" :value="item" v-for="item in productOptions" :key="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="语言" required>
                            <el-select v-model="createForm.language" placeholder="请选择语言" style="width: 260px;">
                                <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <span class="form_tip">进入详情页编辑内容后保存草稿即创建配置。</span>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'h5-quick-start-list',
    data() {
        return {
            loading: false,
            searchProduct: '',
            productOptions: [],
            productMap: {},
            // 汇总后的行：{product, language, fallback, published, hasDraft, hasDraftChange, updatedAt}
            allRows: [],
            tableData: [],
            // 新建
            createForm: {
                product: '',
                language: ''
            },
            delRowItem: null,
            delMsg: ''
        }
    },
    activated() {
        this.init()
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.loadProducts()
        },
        // 产品列表：优先产品管理(psc_product)，回退默认列表
        loadProducts() {
            this.api.pscProductList({}).then(res => {
                if (res.code === 200 && res.data && res.data.list && res.data.list.length > 0) {
                    this.productOptions = res.data.list.map(item => item.model)
                    res.data.list.forEach(item => {
                        this.productMap[item.model] = item
                    })
                } else {
                    this.useDefaultProducts()
                }
                this.loadList()
            }).catch(() => {
                this.useDefaultProducts()
                this.loadList()
            })
        },
        useDefaultProducts() {
            this.productOptions = this.appData.product.slice()
            this.appData.product.forEach(item => {
                this.productMap[item] = { model: item, name: item }
            })
        },
        productName(model) {
            const product = this.productMap[model]
            return (product && product.name) || model
        },
        // 拉全部配置记录（status=-1 不过滤状态），按产品+语言汇总草稿/发布状态
        loadList() {
            this.loading = true
            this.api.quickStartQuery({
                status: -1
            }).then(res => {
                if (res.code === 200 && res.data && res.data.list) {
                    this.allRows = this.mergeRows(res.data.list)
                } else {
                    this.allRows = []
                }
                this.filterTable()
                this.loading = false
            }).catch(() => {
                this.allRows = []
                this.filterTable()
                this.loading = false
            })
        },
        // 草稿和已发布是两条记录，按产品+语言合并为一行
        mergeRows(list) {
            const map = {}
            list.forEach(item => {
                const key = item.product + '|' + item.language
                if (!map[key]) {
                    map[key] = {
                        product: item.product,
                        language: item.language,
                        fallback: '',
                        published: null,
                        draft: null,
                        updatedAt: 0
                    }
                }
                const row = map[key]
                if (item.fallback) {
                    row.fallback = item.fallback
                }
                if (item.status === 1) {
                    row.published = item
                } else {
                    row.draft = item
                }
            })
            const rows = []
            Object.keys(map).forEach(key => {
                const row = map[key]
                row.hasDraft = !!row.draft
                // 已发布但草稿更新时间更晚（或无草稿但有发布记录）→ 标记有待发布修改
                row.hasDraftChange = !!(row.draft && row.published && row.draft.updated_at > row.published.updated_at)
                row.updatedAt = Math.max(
                    row.draft ? row.draft.updated_at : 0,
                    row.published ? row.published.updated_at : 0
                )
                rows.push(row)
            })
            rows.sort((a, b) => {
                if (a.product !== b.product) {
                    return a.product > b.product ? 1 : -1
                }
                return a.language > b.language ? 1 : -1
            })
            return rows
        },
        filterTable() {
            if (this.searchProduct) {
                this.tableData = this.allRows.filter(row => row.product === this.searchProduct)
            } else {
                this.tableData = this.allRows
            }
        },
        goEdit(row) {
            this.$router.push({
                name: 'psc-h5-quick-start-edit',
                query: {
                    product: row.product,
                    language: row.language
                }
            })
        },
        openCreate() {
            this.createForm = {
                product: '',
                language: ''
            }
            this.$refs.createDialog.show = true
        },
        confirmCreate() {
            if (!this.createForm.product || !this.createForm.language) {
                this.$message.warning('请选择产品和语言')
                return
            }
            const product = this.createForm.product
            const language = this.createForm.language
            // 已有草稿的搭配直接跳详情，避免误建重复配置
            const exist = this.allRows.some(row => row.product === product && row.language === language && row.hasDraft)
            this.$refs.createDialog.show = false
            if (exist) {
                this.$message.info('该产品+语言已有配置，直接进入详情')
            }
            this.$router.push({
                name: 'psc-h5-quick-start-edit',
                query: {
                    product: product,
                    language: language
                }
            })
        },
        publishRow(row) {
            this.$confirm('确认发布「' + this.productName(row.product) + ' / ' + (this.appData.lang[row.language] || row.language) + '」的草稿？发布后 H5 立即生效。', '发布确认', {
                confirmButtonText: '发布',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.api.quickStartPublish({
                    product: row.product,
                    language: row.language,
                    status: 0
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('发布成功')
                        this.loadList()
                    } else {
                        this.$message.error(res.msg || '发布失败')
                    }
                })
            }).catch(() => {})
        },
        delRow(row) {
            this.delRowItem = row
            this.delMsg = '确认删除「' + this.productName(row.product) + ' / ' + (this.appData.lang[row.language] || row.language) + '」的配置？草稿和已发布内容将一并删除，H5 将无法再展示该语言页面。'
            this.$refs.tip.show = true
        },
        delConfirm() {
            if (!this.delRowItem) {
                return
            }
            this.api.quickStartDelete({
                product: this.delRowItem.product,
                language: this.delRowItem.language,
                status: -1
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.loadList()
                } else {
                    this.$message.error(res.msg || '删除失败')
                }
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .title_desc {
        margin-top: 8px;
        color: #999;
        font-size: 13px;
    }
    .btn_right_box {
        text-align: right;
    }
    .status_tags {
        display: inline-flex;
        gap: 6px;
        .status_tag {
            display: inline-block;
            padding: 2px 10px;
            border-radius: 10px;
            font-size: 12px;
            &.published {
                background: #E5F5EE;
                color: #21a67a;
            }
            &.none {
                background: #F2F3F8;
                color: #999;
            }
            &.draft {
                background: #FDF3E3;
                color: #d98c1f;
            }
        }
    }
    .form_tip {
        color: #999;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/h5-quick-start-list.vue